import { render, staticRenderFns } from "./calculator.vue?vue&type=template&id=aec16e62&"
import script from "./calculator.vue?vue&type=script&lang=ts&"
export * from "./calculator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wamp\\www\\Pentacom\\baumit.com\\vue-project\\calculator-common\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aec16e62')) {
      api.createRecord('aec16e62', component.options)
    } else {
      api.reload('aec16e62', component.options)
    }
    module.hot.accept("./calculator.vue?vue&type=template&id=aec16e62&", function () {
      api.rerender('aec16e62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/calculator/calculator.vue"
export default component.exports